import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as ReturnCodesConstants from '../../../../../constants/ReturnCodesConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      pageOrder: 'desc',
      pageSort: 'id',
      centerHeight: document.documentElement.clientHeight - 40 +'px',
      type: '0',
      searchInput: '',
      myExtendedInsuranceData:[],
      imgUrl: '',
      centerDialogVisible: false,
      index: ''
    }
  },
  computed: {
    ...mapState('myExtendedInsuranceModule', ['myOrderList'])
  },
  methods: {
    ...mapActions('myExtendedInsuranceModule', ['getMyExtendedInsurance']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    async getMyExtendedInsuranceInfo () {
      let res = await this.getMyExtendedInsurance()
      if (res.code === ReturnCodesConstants.SUCCESS_CODE) {
        let list = res.data.filter((item, index) => {
          if(index === this.index * 1) {
            return item
          }
        })
        this.myExtendedInsuranceData = list
      } else {
        this.$message.error(`查询失败！`)
      }
      console.log(res)
    },
    openDetails () {
      this.$router.push({
        path: RoutePathConstants.MY_EXTENDED_INSURANCE_DETAILS
      })
    },
    openImgDetails (url) {
      this.imgUrl = url
      this.centerDialogVisible = true
    }
  },
  mounted () {
    this.index = this.$route.query.index
    this.getMyExtendedInsuranceInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-extended-insurance/views/my-extended-insurance.js